/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2020 (original work) Open Assessment Technologies SA ;
 */


/**
 * Check if a dataTransfer object (from a drop event) contains some folders.
 * The detection is a best effort since there's no official cross browser way to detect that.
 * @param {DataTransfer} dataTransfer - the transfer object
 * @param {DataTransferItemList} dataTransfer.items - the transfer items (an item let's you access its content)
 * @returns {boolean} true if we detect folders in the transfer
 */
export function containsFolders(dataTransfer) {
    const isEntryAFolder = entry => entry && (entry.isDirectory === true || entry.isFile === false);
    if (dataTransfer && dataTransfer.items && dataTransfer.items.length) {
        for (let item of dataTransfer.items) {
            if (typeof item.getAsEntry === 'function') {
                if (isEntryAFolder(item.getAsEntry())) {
                    return true;
                }
            } else if (typeof item.webkitGetAsEntry === 'function') {
                if (isEntryAFolder(item.webkitGetAsEntry())) {
                    return true;
                }
            }
        }
    }
    return false;
}

/**
 * Get the first file of a dataTransfer object (from drop event)
 * @param {DataTransfer} dataTransfer - the transfer object
 * @param {FileList} dataTransfer.files - the transferred files
 * @returns {File?} the first file if any
 */
export function getFirstFile(dataTransfer) {
    if (dataTransfer && dataTransfer.files && dataTransfer.files.length) {
        return dataTransfer.files[0];
    }
    return null;
}
